export default __webpack_public_path__ + "static/media/opening02.05a00889.jpg";